import VerifyRequestModelBase from '../_generated/modelBases/verify-request-model-base';

export default class VerifyRequestModel extends VerifyRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
